import React, { useEffect } from 'react'
import { motion } from 'framer-motion'

import Footer from '../../components/Footer/Footer'

import CardAdhesion from '../../components/Carousel/CardAdhesion'

import Header from '../../components/Bar/Header'


const Contact = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
   
      <Header />
    

      <CardAdhesion />

     
      <Footer />
    </motion.div>
  )
}

export default Contact
